/**
 * Copyright Mántum All Rights Reserved.
 */
import { useEffect, useRef } from 'react';

export default (callback: () => void) => {
    const ref = useRef(callback);

    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.code === 'Escape') {
                ref.current();
            }
        };

        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);
};
